export default "__VITE_ASSET__cc5079f0__"